<template>
  <div class="action-send-message-editor">
    <!-- Node Intro -->
    <div class="node-intro">
      <div class="node-icon">
        <!-- forward_to_inbox icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#5587BC"/>
        </svg>
      </div>
      <p class="node-description">
        <span class="node-title">Send Message</span> will send a customized message through selected platform once the Trigger event happened.
      </p>
    </div>

    <!-- Message Type Field -->
    <div class="input-section">
      <div class="input-field">
        <Label label="Message Type" :required="true">
          <SingleSelector
            v-model="localFormData.messageType"
            placeholder="Select type..."
            :options="messageTypeOptions"
            size="medium"
            @change="handleInput"
          />
        </Label>
      </div>
    </div>

    <!-- Subject Field -->
    <div class="input-section">
      <div class="input-field">
        <Label label="Subject">
          <TextInput
            v-model="localFormData.subject"
            placeholder="Email subject"
            size="medium"
            @input="handleInput"
          />
        </Label>
      </div>
    </div>

    <!-- Message Content Field -->
    <div class="input-section">
      <div class="input-field">
        <Label label="Message Content">
          <TextArea
            v-model="localFormData.messageContent"
            placeholder="Message content"
            size="medium"
            @input="handleInput"
          />
        </Label>
      </div>
    </div>

    <!-- Save Configuration Button -->
    <SaveConfigure :disabled="!isFormValid" @save-configuration="saveConfiguration" />
  </div>
</template>

<script>
import SaveConfigure from '@/components/workflow/SaveConfigure.vue';

export default {
  name: 'ActionSendMessageEditor',
  components: {
    SaveConfigure
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localFormData: {
        messageType: this.data.messageType || 'in_app',
        subject: this.data.subject || '',
        messageContent: this.data.messageContent || ''
      },
      messageTypeOptions: [
        { label: 'Email', value: 'email' },
        { label: 'SMS', value: 'sms' },
        { label: 'In-App Message', value: 'in_app' }
      ]
    };
  },
  computed: {
    isFormValid() {
      return this.localFormData.messageType && this.localFormData.messageContent && this.localFormData.messageContent.trim().length > 0;
    }
  },
  watch: {
    'data.messageType': {
      handler(newVal) {
        if (newVal !== this.localFormData.messageType) {
          this.localFormData.messageType = newVal || '';
        }
      }
    },
    'data.subject': {
      handler(newVal) {
        if (newVal !== this.localFormData.subject) {
          this.localFormData.subject = newVal || '';
        }
      }
    },
    'data.messageContent': {
      handler(newVal) {
        if (newVal !== this.localFormData.messageContent) {
          this.localFormData.messageContent = newVal || '';
        }
      }
    }
  },
  methods: {
    handleInput() {
      // Update the shared data instance directly
      this.data.messageType = this.localFormData.messageType;
      this.data.subject = this.localFormData.subject;
      this.data.messageContent = this.localFormData.messageContent;
    },
    saveConfiguration() {
      const isValid = this.localFormData.messageType &&
                     this.localFormData.messageContent &&
                     this.localFormData.messageContent.trim().length > 0;

      this.$emit('save', {
        messageType: this.localFormData.messageType,
        subject: this.localFormData.subject,
        messageContent: this.localFormData.messageContent,
        configured: isValid
      });
    }
  }
};
</script>

<style scoped>
.action-send-message-editor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* Node Intro */
.node-intro {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 16px;
  background: #E4F3F5;
  border-radius: 5px;
}

.node-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.node-description {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #5587BC;
  margin: 0;
}

.node-title {
  font-weight: 700;
}

/* Input Section */
.input-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.input-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  height: 24px;
  display: flex;
  align-items: center;
}

.required-mark {
  color: #D10000;
}

.input-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  height: 24px;
  display: flex;
  align-items: center;
}

.required-mark {
  color: #D10000;
}
</style>
